import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

export default class ProductTrackContributor extends Model {
  @attr('boolean') mainContributor;
  @attr('number') position;

  // Relation
  @belongsTo('category', { async: true, inverse: null }) category;
  @belongsTo('artist', { async: true, inverse: null }) artist;
  @belongsTo('product-track', { async: true, inverse: 'contributors' })
  productTrack;
}
